import React from "react";

export const SideBarContext = React.createContext({
  collapsed: false,
  toggleCollapsed: () => {
    // do nothing
  },
});
